import { req } from './axiosFun'
import config from './config'

var url = config.apiBase

export const wxtokenPage = (params) => { return req("get", url + "/admin/web/wxTokenPage", params) }



// WEBPACK FOOTER //
// ./src/api/wxtokenMG.js